// Admin Statistics

<template>
	<div class="stats-main">

		<div class="header wi8_font">
			Site Statistics<br/>
			<button @click="goRequest">Refresh</button>
		</div>

		<div class="detail">
			<div v-if="stats.cols.length>0" >
				<div class="cell">{{ stats.cols[1] }}</div>
				<div class="cell">{{ stats.cols[2] }}</div>
				<div class="cell">{{ stats.cols[3] }}</div>
				<div class="cell">{{ stats.cols[4] }}</div>
			</div>

			<div v-for="(row, idx) in stats.rows" :key="'row'+idx" >
				<div class="cell">{{ row[1] }}</div>
				<div class="cell">{{ row[2] }}</div>
				<div class="cell">{{ row[3] }}</div>
				<div class="cell">{{ row[4] }}</div>
			</div>
		</div>

	</div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from "@/main";
import { mapState, mapGetters } from "vuex";
export default {
	computed: {
		...mapState('app',['stats']),
	},
	methods: {
		goRequest() {
			m("go request");

			const payloadRequest = {
				popType: "win",
				popTitle: "Requesting Statistics",
				popText: "",
				compName: "UniPost",
				compData: {
					step: "stats",
					autoPost: true,
				},
			};

			eventBus.$emit("popup", payloadRequest);	
		},
	},
}
</script>

<style scoped>
.stats-main {
	height: 100%;
	overflow-x:hidden;
	overflow-y: auto;
	background-color: #F9FFF9;
	padding: 10px;
	border: solid 0px #C30;
}

.header {
	height: 50px;
	overflow: hidden;
	text-align: center;
	color: #369;
	border: solid 0px #369;
}

button {
	width: 100px;
}

.detail {
	text-align: center;
	border: solid 0px #C00;
}

.cell {
	display: inline-block;
	width: 60px;
	height: 25px;
	overflow: hidden;
	text-align: right;
	background-color: #F9FFF9;
	padding: 0px;
	border: solid 0px #090;
	border-bottom: solid 1px #999;
}

.clear {
	clear: both;
}

</style>
